<template>
  <div>
    <div v-if="loading" class="product-row-loading">
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>

    <div v-else-if="!products.length" class="empty-row">
      {{ emptyText }}
    </div>

    <div v-else class="brand-section-list">
      <v-card
        v-for="group in groupedProducts"
        :key="group.name"
        outlined
        class="brand-home-box"
      >
        <div class="brand-home-header">
          <div class="brand-home-title">{{ group.name }}</div>

          <button
            v-if="group.hiddenCount > 0"
            class="brand-view-btn"
            @click.stop="$emit('view-brand', group.name)"
          >
            View all
          </button>
        </div>

        <div class="brand-product-grid">
          <div
            v-for="product in group.products"
            :key="product.id"
            class="brand-product-card"
            @click="$emit('open', product)"
          >
            <div class="brand-image-wrap">
              <v-img
                v-if="product.imageUrl"
                :src="product.imageUrl"
                height="104"
                contain
                class="brand-product-image"
              />

              <v-img
                v-else
                src="@/assets/images/photoComingSoon.png"
                height="104"
                contain
                class="brand-product-image"
              />
            </div>

            <div class="brand-product-name">
              {{ product.name }}
            </div>

            <div v-if="showPrices" class="brand-product-price">
              {{ product.price | currency }}
            </div>
            <button v-else class="price-login-link" @click.stop="$emit('login')"><v-icon x-small>mdi-lock-outline</v-icon> Log in to see price</button>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductRow",

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: "No products found",
    },
    maxPerBrand: {
      type: Number,
      default: 4,
    },
    showPrices: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    groupedProducts() {
      const map = {};

      this.products.forEach((product) => {
        const brandName =
          product.Brand && product.Brand.name
            ? product.Brand.name
            : "Featured Products";

        if (!map[brandName]) {
          map[brandName] = [];
        }

        map[brandName].push(product);
      });

      return Object.keys(map)
        .sort((a, b) => a.localeCompare(b))
        .map((brandName) => {
          const allProducts = map[brandName].sort((a, b) => {
            return String(a.name || "").localeCompare(String(b.name || ""));
          });

          return {
            name: brandName,
            products: allProducts.slice(0, this.maxPerBrand),
            hiddenCount: Math.max(allProducts.length - this.maxPerBrand, 0),
          };
        });
    },
  },
};
</script>

<style scoped>
.brand-section-list {
  padding: 0 18px 18px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.brand-home-box {
  background: #ffffff;
  border-radius: 18px !important;
  padding: 14px;
  min-height: 310px;
  overflow: hidden;
  border: 1px solid #dbe3ef !important;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.brand-home-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.brand-home-title {
  font-size: 18px;
  font-weight: 900;
  color: #111827;
  line-height: 1.2;
}

.brand-view-btn {
  border: 1px solid #dbe3ef;
  background: #ffffff;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 800;
  color: #111827;
  cursor: pointer;
  white-space: nowrap;
}

.brand-product-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.brand-product-card {
  cursor: pointer;
  border-radius: 10px;
  padding: 4px;
  background: transparent;
  transition: all 0.15s ease;
}

.brand-product-card:hover {
  transform: translateY(-2px);
}

.brand-image-wrap {
  height: 112px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.brand-product-image {
  background: #f8fafc;
}

.brand-product-name {
  margin-top: 7px;
  font-size: 12px;
  font-weight: 800;
  color: #111827;
  line-height: 1.22;
  min-height: 30px;
  max-height: 30px;
  overflow: hidden;
}

.brand-product-price {
  margin-top: 5px;
  font-size: 15px;
  font-weight: 900;
  color: #111827;
}
.price-login-link{margin-top:5px;color:#2563eb;font-size:12px;font-weight:800;display:flex;align-items:center;gap:3px;cursor:pointer}

.product-row-loading,
.empty-row {
  min-height: 160px;
  margin: 0 18px 18px;
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  background: #ffffff;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}


@media (max-width: 1180px) {
  .brand-section-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 840px) {
  .brand-section-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .brand-section-list {
    padding: 0 12px 18px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    overflow: visible;
  }

  .brand-home-box {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    background: #ffffff !important;
    border: 0 !important;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06) !important;
    border-radius: 18px !important;
    padding: 14px;
    min-height: auto;
    overflow: hidden;
  }

  .brand-home-header {
    margin-bottom: 12px;
    padding: 0;
  }

  .brand-home-title {
    font-size: 22px;
    line-height: 1.15;
  }

  .brand-product-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .brand-product-card {
    min-width: 0;
    padding: 0;
  }

  .brand-image-wrap {
    height: 132px;
    background: #f8fafc;
    border: 0 !important;
    border-radius: 14px;
  }

  .brand-product-image {
    background: #f8fafc;
  }

  .brand-product-name {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.25;
    min-height: 48px;
    max-height: 48px;
    overflow: hidden;
  }

  .brand-product-price {
    margin-top: 6px;
    font-size: 18px;
  }
}
</style>
